// /about: подсказка над страной на карте мира [data-provide="world-map"].
//
// Контуры и статусы стран приходят готовыми в разметке (data-name, data-used,
// data-customers), скрипт только показывает плавающую подсказку у курсора.
// Подпись «используется / не используется» берётся из легенды карты, поэтому
// своих строк у скрипта нет.

(function () {
    "use strict";

    const map = document.querySelector<HTMLElement>('[data-provide="world-map"]');
    const tip = map?.querySelector<HTMLElement>(".about-map-tip");
    if (!map || !tip) {
        return;
    }

    const keys = map.querySelectorAll<HTMLElement>(".about-map-key");
    const labelUsed = keys[0]?.textContent?.trim() ?? "";
    const labelNotUsed = keys[1]?.textContent?.trim() ?? "";

    function hide(): void {
        tip!.hidden = true;
    }

    function show(path: SVGElement, event: PointerEvent): void {
        const used = path.dataset.used === "1";
        const customers = path.dataset.customers;

        tip!.replaceChildren(
            Object.assign(document.createElement("strong"), { textContent: path.dataset.name ?? "" }),
            Object.assign(document.createElement("small"), {
                textContent: used
                    ? (customers ? `${labelUsed} · ${customers}` : labelUsed)
                    : labelNotUsed
            }));
        tip!.hidden = false;

        const box = map!.getBoundingClientRect();
        const half = tip!.offsetWidth / 2;
        // Подсказка центрируется над курсором, но не выходит за края карты.
        const x = Math.min(Math.max(event.clientX - box.left, half), box.width - half);
        tip!.style.left = `${x}px`;
        tip!.style.top = `${event.clientY - box.top}px`;
    }

    map.addEventListener("pointermove", (event) => {
        const target = (event.target as Element).closest<SVGElement>(".about-map-country");
        if (target) {
            show(target, event);
        } else {
            hide();
        }
    });

    map.addEventListener("pointerleave", hide);
})();
